/* SUNVOLT produktkonfigurator – steg-för-steg-guide, 100 % i sync med produktsidans upplägg.
   Serverrenderade steg (sections/sunvolt-configurator.liquid, produktmall product.konfigurator):
   varianter, installation (gront-avdrag-taggad), grupperade/ogrupperade tillval ur metafältet.
   Prismatte = main-product-tibber: total = bas + tillval; grönt avdrag (settings.sv_gront_percent)
   när installation är vald; hanteringsavgift när laddbox köps utan installation; kunden betalar
   total − avdrag + avgift. Kassa: bas + valda tillval + ev. avgiftsprodukt via /cart/add.js
   (Regios ger rabatten i kassan, sunvolt-fee.js håller avgiften i korgen). Alla priser i ÖRE. */
(function () {
  'use strict';

  function fmt(ore) {
    var kr = Math.round(ore / 100);
    return kr.toLocaleString('sv-SE') + ' kr';
  }

  function init(root) {
    if (!root || root.__svcInit) return;
    root.__svcInit = true;

    var cfgEl = root.querySelector('[data-svc-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
    var progress = root.querySelector('[data-progress]');
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var nextLabel = root.querySelector('[data-next-label]');
    var totalEl = root.querySelector('[data-total]');
    var strikeEl = root.querySelector('[data-strike]');
    var monthEl = root.querySelector('[data-month]');
    var barSave = root.querySelector('[data-bar-save]');
    var barSaveV = root.querySelector('[data-bar-save-v]');

    var current = 0;
    var visited = 0; /* längsta steg användaren nått – styr bock-markering */
    var baseVariantId = cfg.baseVariantId;
    var basePrice = cfg.basePrice || 0;
    var baseCompare = cfg.baseCompare || 0; /* ordinarie pris vid rea (compare_at_price) */
    var baseTitle = cfg.productTitle || '';

    /* Månadspris med SAMMA Zaver-formel som produktsidan: annuitet (nominell ränta) +
       administrationsavgift/mån – verifierad mot Zavers kalkylator. Belopp i öre in. */
    var zvN = parseInt(cfg.zaverMonths, 10) || 24;
    var zvRate = parseFloat(String(cfg.zaverRate || '').replace(',', '.')) || 0;
    var zvFee = parseFloat(cfg.zaverFee) || 0;
    var zvR = zvRate / 100 / 12;
    function zaverMonthly(shownCents) {
      var P = shownCents / 100;
      var m = zvR > 0 ? P * zvR / (1 - Math.pow(1 + zvR, -zvN)) : P / zvN;
      return Math.round(m + zvFee).toLocaleString('sv-SE') + ' kr';
    }

    /* Stegnummer i panelrubrikerna */
    panels.forEach(function (p, i) {
      var no = p.querySelector('[data-step-no]');
      if (no) no.textContent = i + 1;
    });

    /* ===== Modell (variant-kort) ===== */
    var variantCards = Array.prototype.slice.call(root.querySelectorAll('[data-variant-card]'));
    function selectVariant(card) {
      variantCards.forEach(function (c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false'); });
      card.classList.add('is-selected');
      card.setAttribute('aria-checked', 'true');
      baseVariantId = parseInt(card.getAttribute('data-variant-id'), 10);
      basePrice = parseFloat(card.getAttribute('data-price')) || 0;
      baseCompare = parseFloat(card.getAttribute('data-compare')) || 0;
      baseTitle = cfg.productTitle + ' – ' + (card.getAttribute('data-title') || '');
      var img = card.getAttribute('data-image');
      if (img) {
        var thumb = root.querySelector('[data-bar-thumb] img');
        if (thumb) thumb.src = img;
        var hero = root.querySelector('[data-summary-media] img');
        if (hero) hero.src = img;
      }
      recalc();
    }
    variantCards.forEach(function (card) {
      card.addEventListener('click', function () { if (!card.disabled) selectVariant(card); });
      if (parseInt(card.getAttribute('data-variant-id'), 10) === cfg.baseVariantId) {
        card.classList.add('is-selected');
        card.setAttribute('aria-checked', 'true');
        baseTitle = cfg.productTitle + ' – ' + (card.getAttribute('data-title') || '');
      }
    });

    /* ===== Fler-alternativ-produkt: ETT steg per option (t.ex. Kilowatt → Växelriktare).
       Kort per värde; varianten löses ur kombinationen av valda värden. Värden utan
       tillgänglig kombination givet TIDIGARE stegs val stängs av, och blir ett senare
       stegs val ogiltigt hoppar det till första möjliga värde (kaskad). ===== */
    var varDataEl = root.querySelector('[data-svc-variants]');
    var optCards = Array.prototype.slice.call(root.querySelectorAll('[data-opt-card]'));
    if (varDataEl && optCards.length) {
      var allVariants = [];
      try { allVariants = JSON.parse(varDataEl.textContent) || []; } catch (e2) { allVariants = []; }
      var optCount = 0;
      optCards.forEach(function (c) { var i = parseInt(c.getAttribute('data-opt-index'), 10); if (i + 1 > optCount) optCount = i + 1; });
      var chosen = new Array(optCount);
      var cardsFor = function (idx) { return optCards.filter(function (c) { return parseInt(c.getAttribute('data-opt-index'), 10) === idx; }); };
      var matchesBefore = function (v, idx) {
        for (var i = 0; i < idx; i++) { if (chosen[i] != null && v.opts[i] !== chosen[i]) return false; }
        return true;
      };
      var refreshDisabled = function () {
        optCards.forEach(function (c) {
          var idx = parseInt(c.getAttribute('data-opt-index'), 10);
          var val = c.getAttribute('data-value');
          var any = allVariants.some(function (v) { return v.available && v.opts[idx] === val && matchesBefore(v, idx); });
          c.disabled = !any;
        });
      };
      var markSelected = function (card) {
        var idx = parseInt(card.getAttribute('data-opt-index'), 10);
        cardsFor(idx).forEach(function (c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false'); });
        card.classList.add('is-selected');
        card.setAttribute('aria-checked', 'true');
        chosen[idx] = card.getAttribute('data-value');
      };
      var applyResolved = function () {
        var v = null;
        for (var k = 0; k < allVariants.length; k++) {
          var ok = true;
          for (var i = 0; i < optCount; i++) { if (allVariants[k].opts[i] !== chosen[i]) { ok = false; break; } }
          if (ok) { v = allVariants[k]; break; }
        }
        if (v) {
          baseVariantId = v.id;
          basePrice = v.price;
          baseCompare = v.compare || 0;
          baseTitle = cfg.productTitle + ' – ' + v.title;
          if (v.image) {
            var thumb = root.querySelector('[data-bar-thumb] img');
            if (thumb) thumb.src = v.image;
            var hero = root.querySelector('[data-summary-media] img');
            if (hero) hero.src = v.image;
          }
        }
        recalc();
      };
      var selectOpt = function (card) {
        markSelected(card);
        refreshDisabled();
        var idx = parseInt(card.getAttribute('data-opt-index'), 10);
        for (var li = idx + 1; li < optCount; li++) {
          var group = cardsFor(li);
          var sel = group.filter(function (c) { return c.classList.contains('is-selected'); })[0];
          if (!sel || sel.disabled) {
            var first = group.filter(function (c) { return !c.disabled; })[0];
            if (first) { selectOpt(first); return; }
          }
        }
        applyResolved();
      };
      optCards.forEach(function (card) {
        card.addEventListener('click', function () { if (!card.disabled) selectOpt(card); });
      });
      /* Förval: basvariantens värden (eller första tillgängliga variant) */
      var initV = null, vk;
      for (vk = 0; vk < allVariants.length; vk++) { if (allVariants[vk].id === cfg.baseVariantId) { initV = allVariants[vk]; break; } }
      if (!initV) { for (vk = 0; vk < allVariants.length; vk++) { if (allVariants[vk].available) { initV = allVariants[vk]; break; } } }
      if (initV) {
        for (var oi = 0; oi < optCount; oi++) {
          (function (i) {
            var target = cardsFor(i).filter(function (c) { return c.getAttribute('data-value') === initV.opts[i]; })[0];
            if (target) markSelected(target);
          })(oi);
        }
        refreshDisabled();
        baseVariantId = initV.id;
        basePrice = initV.price;
        baseCompare = initV.compare || 0;
        baseTitle = cfg.productTitle + ' – ' + initV.title;
      }
    }

    /* ===== Installation (radio-kort) ===== */
    var installStep = root.querySelector('[data-install-step]');
    var installOpts = Array.prototype.slice.call(root.querySelectorAll('[data-install-opt]'));
    function selectInstall(opt) {
      installOpts.forEach(function (o) { o.classList.remove('is-selected'); o.setAttribute('aria-checked', 'false'); });
      opt.classList.add('is-selected');
      opt.setAttribute('aria-checked', 'true');
      recalc();
    }
    installOpts.forEach(function (opt) {
      opt.addEventListener('click', function () { if (!opt.disabled) selectInstall(opt); });
    });
    /* Förvälj första valbara installationen (som produktsidans förbockade installation) */
    for (var i = 0; i < installOpts.length; i++) {
      if (!installOpts[i].disabled) { installOpts[i].classList.add('is-selected'); installOpts[i].setAttribute('aria-checked', 'true'); break; }
    }

    /* ===== Tillvals-rader (radio-grupper + checkboxar) ===== */
    var addonRows = Array.prototype.slice.call(root.querySelectorAll('[data-addon]'));
    function syncRowStates() {
      addonRows.forEach(function (row) {
        var input = row.querySelector('[data-addon-input]');
        row.classList.toggle('is-selected', !!input && input.checked);
      });
      /* Avstå-rader (radio utan data-addon) */
      Array.prototype.forEach.call(root.querySelectorAll('[data-group-skip]'), function (skip) {
        var lab = skip.closest('.svc__row');
        if (lab) lab.classList.toggle('is-selected', skip.checked);
      });
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-addon-input], [data-group-skip]'), function (input) {
      input.addEventListener('change', function () { syncRowStates(); recalc(); });
    });
    /* Klick VAR SOM HELST på raden väljer den. Krävs explicit: raden är en <label>, och en
       label aktiverar sitt FÖRSTA labelbara barn – i rader med variantväljare är det
       <select>-en (inte radion) → blockklick gjorde inget. Select/radio sköter sig själva. */
    addonRows.concat(Array.prototype.slice.call(root.querySelectorAll('.svc__row:not([data-addon])'))).forEach(function (row) {
      row.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        if (e.target.closest('input')) return;
        e.preventDefault();
        var input = row.querySelector('[data-addon-input], [data-group-skip]');
        if (!input || input.disabled || input.checked) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    /* Variant-dropdown i rad: uppdatera pris + variant */
    Array.prototype.forEach.call(root.querySelectorAll('[data-addon-variant]'), function (sel) {
      sel.addEventListener('change', function () {
        var row = sel.closest('[data-addon]');
        var opt = sel.options[sel.selectedIndex];
        if (!row || !opt) return;
        row.setAttribute('data-variant-id', opt.value);
        row.setAttribute('data-price', opt.getAttribute('data-price') || '0');
        recalc();
      });
      sel.addEventListener('click', function (e) { e.stopPropagation(); });
    });

    /* ===== Insamling – speglar produktsidans selectedAddons() ===== */
    function selectedInstall() {
      for (var i = 0; i < installOpts.length; i++) {
        if (installOpts[i].classList.contains('is-selected')) return installOpts[i];
      }
      return null;
    }
    function collect() {
      var items = [];
      var inst = selectedInstall();
      /* Transparensrutan hör bara ihop med en vald installation */
      var instInfo = root.querySelector('[data-install-info]');
      if (instInfo) instInfo.hidden = !(inst && !inst.hasAttribute('data-install-none'));
      if (inst && !inst.hasAttribute('data-install-none')) {
        items.push({
          title: inst.getAttribute('data-title') || 'Installation',
          price: parseFloat(inst.getAttribute('data-price')) || 0,
          variant: parseInt(inst.getAttribute('data-variant-id'), 10) || 0,
          extra: parseInt(inst.getAttribute('data-extra-variant'), 10) || 0,
          gront: inst.getAttribute('data-gront') === 'true'
        });
      }
      addonRows.forEach(function (row) {
        var input = row.querySelector('[data-addon-input]');
        if (!input || !input.checked || input.disabled) return;
        /* Vald variant (t.ex. "3 m") med i titeln → syns i summeringen */
        var t = row.getAttribute('data-title') || '';
        var sel = row.querySelector('[data-addon-variant]');
        if (sel && sel.selectedIndex > -1) {
          var vt = sel.options[sel.selectedIndex].getAttribute('data-vtitle') || '';
          if (vt && vt !== 'Default Title') t += ' – ' + vt;
        }
        items.push({
          title: t,
          price: parseFloat(row.getAttribute('data-price')) || 0,
          variant: parseInt(row.getAttribute('data-variant-id'), 10) || 0,
          extra: 0,
          gront: row.getAttribute('data-gront') === 'true'
        });
      });
      return items;
    }

    /* ===== Tillvalspriser efter grönt avdrag =====
       Avdraget räknas på HELA ordern när ett gront-avdrag-taggat tillval
       (installationen) ligger med – se recalc. Alltså gäller procenten även
       tillbehören, och då ska varje rad visa det pris kunden faktiskt betalar
       i stället för bruttopriset. Utan installation finns inget avdrag, och
       då är bruttopriset det sanna.

       Raderna målas om vid varje omräkning, inte en gång vid start: kunden
       kan lägga till eller ta bort installationen när som helst, och priserna
       måste följa med. Rader som är slut i lager rörs inte – där står en
       lagertext, inte ett pris. */
    function paintRowPrices(pct) {
      var suffix = cfg.labels && cfg.labels.grontShort ? cfg.labels.grontShort : 'efter avdrag';

      Array.prototype.forEach.call(root.querySelectorAll('[data-addon]'), function (row) {
        var pe = row.querySelector('[data-row-price]');
        if (!pe) return;
        var input = row.querySelector('[data-addon-input]');
        if (input && input.disabled) return;

        var gross = parseFloat(row.getAttribute('data-price')) || 0;
        var net = pct > 0 ? gross - Math.round(gross * pct / 100) : gross;

        pe.textContent = '+ ' + fmt(net);
        if (pct > 0) {
          var note = document.createElement('small');
          note.textContent = ' ' + suffix;
          pe.appendChild(note);
        }
        pe.classList.toggle('is-gront', pct > 0);
      });

      /* Korten i modell- och installationsstegen. De renderas med olika
         omgivning – "Från", strykpris, plus- och minustecken – så bara
         själva beloppet bär en krok och skrivs om. Text som "Ingår i
         priset", hanteringsavgiften och "Ingen installation" saknar krok
         med flit: de ger inget avdrag och ska visa sitt verkliga belopp. */
      Array.prototype.forEach.call(root.querySelectorAll('[data-card-amount]'), function (el) {
        var g = parseFloat(el.getAttribute('data-gross'));
        if (isNaN(g)) return;
        el.textContent = fmt(pct > 0 ? g - Math.round(g * pct / 100) : g);
      });

      /* Variantlistan visar samma pris som raden, annars säger de emot
         varandra i samma kort. */
      Array.prototype.forEach.call(root.querySelectorAll('[data-addon-variant]'), function (sel) {
        Array.prototype.forEach.call(sel.options, function (o) {
          var g = parseFloat(o.getAttribute('data-price')) || 0;
          var n = pct > 0 ? g - Math.round(g * pct / 100) : g;
          var t = o.getAttribute('data-vtitle') || '';
          o.textContent = (t ? t + ' – ' : '') + fmt(n);
        });
      });
    }

    /* ===== Prismatte – identisk med main-product-tibber ===== */
    function recalc() {
      var items = collect();
      var addonTotal = items.reduce(function (s, it) { return s + it.price; }, 0);
      var total = basePrice + addonTotal;
      var grontChecked = items.some(function (it) { return it.gront; });
      var deduction = 0;
      if (cfg.grontPercent > 0 && grontChecked) deduction = Math.round(total * cfg.grontPercent / 100);
      paintRowPrices(grontChecked ? cfg.grontPercent : 0);
      var inst = selectedInstall();
      var noInstall = !!inst && inst.hasAttribute('data-install-none');
      var fee = 0;
      if (cfg.feeEnabled && cfg.isLaddbox && installStep && noInstall && !grontChecked) fee = cfg.feePrice;
      /* Kampanjrabatt: fast belopp som Shopifys automatiska rabatt drar i kassan NÄR installation
         ligger med (std/uppgraderad). Gäller ej "ingen installation". Speglar rabatten redan här. */
      var installDiscount = (inst && !noInstall && cfg.installDiscount > 0) ? cfg.installDiscount : 0;
      var shown = total - deduction + fee - installDiscount;
      if (shown < 0) shown = 0;
      /* Ordinarie pris (utan rea + utan grönt) → strykpris & besparing speglar rabatterna. */
      var origBase = (baseCompare > basePrice) ? baseCompare : basePrice;
      var onSale = baseCompare > basePrice;
      var origTotal = origBase + addonTotal;
      var totalSaving = origTotal - shown;

      if (totalEl) {
        totalEl.textContent = fmt(shown);
        /* data-tb-amount = det kunden betalar (öre) – läses live av Zaver-raden (från-pris + popup) */
        totalEl.setAttribute('data-tb-amount', shown);
        totalEl.classList.add('is-pop');
        setTimeout(function () { totalEl.classList.remove('is-pop'); }, 180);
      }
      if (strikeEl) {
        if (origTotal > shown) { strikeEl.textContent = fmt(origTotal); strikeEl.hidden = false; }
        else { strikeEl.hidden = true; }
      }
      /* Månadspris = SAMMA Zaver-formel som produktsidan: annuitet + administrationsavgift */
      if (monthEl) monthEl.textContent = zaverMonthly(shown);
      if (barSave) {
        barSave.hidden = totalSaving <= 0;
        if (barSaveV) barSaveV.textContent = fmt(totalSaving);
      }
      /* Grönt teknik-avdrag-uppgifterna (personnr + fastighet) behövs bara när avdraget gäller */
      var grontWrap = root.querySelector('[data-svc-gront-wrap]');
      if (grontWrap) {
        grontWrap.hidden = !grontChecked;
        var box = grontWrap.querySelector('[data-sv-gront]');
        if (box) box.setAttribute('data-required', grontChecked ? 'true' : 'false');
      }
      buildSummary(items, total, deduction, fee, shown, onSale ? baseCompare : 0, installDiscount);
    }

    /* ===== Summering ===== */
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function buildSummary(items, total, deduction, fee, shown, baseCmp, campaign) {
      var body = root.querySelector('[data-summary-rows]');
      if (!body) return;
      /* Rea på basvarianten → visa ordinarie pris överstruket bredvid rea-priset */
      var baseVal = (baseCmp && baseCmp > basePrice)
        ? '<s class="svc__sum-was">' + fmt(baseCmp) + '</s> ' + fmt(basePrice)
        : fmt(basePrice);
      var html = '<div class="svc__sum-row"><span>' + esc(baseTitle) + '</span><span class="v">' + baseVal + '</span></div>';
      items.forEach(function (it) {
        html += '<div class="svc__sum-row"><span>' + esc(it.title) + '</span><span class="v">+ ' + fmt(it.price) + '</span></div>';
      });
      if (deduction > 0) html += '<div class="svc__sum-row svc__sum-row--gront"><span>' + esc(cfg.labels.gront) + ' (−' + String(cfg.grontPercent).replace('.', ',') + ' %)</span><span class="v">−' + fmt(deduction) + '</span></div>';
      if (campaign > 0) html += '<div class="svc__sum-row svc__sum-row--campaign"><span>' + esc(cfg.labels.campaign) + '</span><span class="v">−' + fmt(campaign) + '</span></div>';
      if (fee > 0) html += '<div class="svc__sum-row svc__sum-row--fee"><span>' + esc(cfg.labels.fee) + '</span><span class="v">+ ' + fmt(fee) + '</span></div>';
      html += '<div class="svc__sum-row svc__sum-row--total"><span>' + esc(cfg.labels.total) + '</span><span class="v">' + fmt(shown) + '</span></div>';
      body.innerHTML = html;

      var note = root.querySelector('[data-save-note]');
      if (note) {
        note.classList.toggle('is-on', deduction > 0);
        var amount = note.querySelector('[data-save-amount]');
        if (amount) amount.textContent = fmt(deduction);
      }
      var sub = root.querySelector('[data-summary-sub]');
      if (sub) {
        var parts = items.map(function (it) { return it.title; });
        sub.textContent = parts.length ? parts.join(' · ') : 'Inga tillval valda';
      }
    }

    /* ===== Steg-navigering ===== */
    function show(i) {
      current = Math.max(0, Math.min(panels.length - 1, i));
      if (current > visited) visited = current;
      panels.forEach(function (p, idx) { p.hidden = idx !== current; });
      tabs.forEach(function (t, idx) {
        t.classList.toggle('is-active', idx === current);
        t.classList.toggle('is-done', idx < visited && idx !== current);
        t.setAttribute('aria-current', idx === current ? 'step' : 'false');
      });
      if (progress) progress.style.width = ((current + 1) / panels.length * 100) + '%';
      /* Håll aktiv flik synlig i flik-raden (mobil: raden scrollar horisontellt) */
      if (tabs[current] && tabs[current].scrollIntoView) {
        try { tabs[current].scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); } catch (e) {}
      }
      if (prevBtn) prevBtn.disabled = current === 0;
      var last = current === panels.length - 1;
      var lastLabel = cfg.quoteMode ? (cfg.labels.quote || 'Skicka offertförfrågan') : cfg.labels.checkout;
      if (nextLabel) nextLabel.textContent = last ? lastLabel : (tabs[current + 1] ? tabs[current + 1].getAttribute('data-label') : '');
      try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    }
    tabs.forEach(function (t, idx) { t.addEventListener('click', function () { show(idx); }); });
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (current === panels.length - 1) checkout();
      else show(current + 1);
    });

    /* ===== Grönt-uppgifter: validering (samma regler som sunvolt-gront.js) ===== */
    function luhnOk(pnr) {
      var d = (pnr || '').replace(/\D/g, '');
      if (d.length === 12) d = d.slice(2);
      if (d.length !== 10) return false;
      var sum = 0, i, n;
      for (i = 0; i < 10; i++) {
        n = parseInt(d.charAt(i), 10);
        if (i % 2 === 0) { n *= 2; if (n > 9) n -= 9; }
        sum += n;
      }
      return sum % 10 === 0;
    }
    function grontField(name) { return root.querySelector('[data-sv-gront-field="' + name + '"]'); }
    function grontVal(name) { var f = grontField(name); return f ? f.value.trim() : ''; }
    function grontFieldsValid() {
      var p = grontVal('pnr');
      var pnrOk = /^(\d{2})?\d{6}[-+]?\d{4}$/.test(p) && luhnOk(p);
      return pnrOk && grontVal('fastighet').length > 0;
    }
    function revealGrontErrors() {
      var p = grontVal('pnr');
      var pnrOk = /^(\d{2})?\d{6}[-+]?\d{4}$/.test(p) && luhnOk(p);
      var fastOk = grontVal('fastighet').length > 0;
      root.querySelectorAll('[data-sv-gront-err="pnr"]').forEach(function (e) { e.hidden = pnrOk; });
      root.querySelectorAll('[data-sv-gront-err="fastighet"]').forEach(function (e) { e.hidden = fastOk; });
      var pf = grontField('pnr'); if (pf) pf.classList.toggle('is-error', !pnrOk);
      var ff = grontField('fastighet'); if (ff) ff.classList.toggle('is-error', !fastOk);
    }
    function grontActive() {
      var wrap = root.querySelector('[data-svc-gront-wrap]');
      return !!wrap && !wrap.hidden;
    }

    /* ===== Kassa – bas + valda tillval + ev. avgift (fee-JS:en stämmer av korgen) ===== */
    function checkout() {
      /* Offert-läge: ingen kassa – öppna offert-modalen med hela konfigurationen ifylld. */
      if (cfg.quoteMode) { openQuote(); return; }
      /* Grönt avdrag valt → uppgifterna måste vara ifyllda innan kassan */
      if (grontActive() && !grontFieldsValid()) {
        show(panels.length - 1);
        revealGrontErrors();
        var pf = grontField('pnr');
        if (pf) { try { pf.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} pf.focus(); }
        return;
      }
      var items = [{ id: baseVariantId, quantity: 1 }];
      collect().forEach(function (it) {
        if (it.variant) items.push({ id: it.variant, quantity: 1 });
        if (it.extra) items.push({ id: it.extra, quantity: 1 });
      });
      var inst = selectedInstall();
      var grontChecked = collect().some(function (it) { return it.gront; });
      if (cfg.feeEnabled && cfg.isLaddbox && installStep && inst && inst.hasAttribute('data-install-none') && !grontChecked) {
        items.push({ id: cfg.feeVariantId, quantity: 1 });
      }
      nextBtn.classList.add('is-loading');
      fetch(cfg.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status) {
            nextBtn.classList.remove('is-loading');
            alert(data.description || 'Kunde inte lägga i kundvagnen.');
            return null;
          }
          /* Grönt-uppgifterna → order-attribut (följer ordern till fakturan), innan kassan */
          if (grontActive()) {
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ attributes: { Personnummer: grontVal('pnr'), Fastighetsbeteckning: grontVal('fastighet') } })
            }).catch(function () {});
          }
          return true;
        })
        .then(function (ok) {
          if (ok === null) return;
          window.location.href = cfg.checkoutAction === 'cart' ? cfg.cartUrl : '/checkout';
        })
        .catch(function () { window.location.href = cfg.cartUrl; });
    }

    /* ===== OFFERT-LÄGE: bygg hela konfigurationen + öppna Shopify-kontaktformulär i modal =====
       Ingen kassa/varukorg. Kundens val (bas + alla tillval + total) serialiseras till dolda
       contact[...]-fält (följer med i offert-mejlet) och visas som en sammanfattning i modalen. */
    var quoteWrap = root.querySelector('[data-quote-wrap]');

    function quoteTotals() {
      var items = collect();
      var addonTotal = items.reduce(function (s, it) { return s + it.price; }, 0);
      var total = basePrice + addonTotal;
      var grontChecked = items.some(function (it) { return it.gront; });
      var deduction = (cfg.grontPercent > 0 && grontChecked) ? Math.round(total * cfg.grontPercent / 100) : 0;
      var inst = selectedInstall();
      var noInstall = !!inst && inst.hasAttribute('data-install-none');
      var fee = (cfg.feeEnabled && cfg.isLaddbox && installStep && noInstall && !grontChecked) ? cfg.feePrice : 0;
      return { items: items, total: total, deduction: deduction, fee: fee, shown: total - deduction + fee };
    }

    function quoteData() {
      var c = quoteTotals();
      var rows = [{ label: baseTitle, value: fmt(basePrice) }];
      var lines = [baseTitle + ': ' + fmt(basePrice)];
      c.items.forEach(function (it) {
        rows.push({ label: it.title, value: '+ ' + fmt(it.price) });
        lines.push('+ ' + it.title + ': ' + fmt(it.price));
      });
      if (c.deduction > 0) { rows.push({ label: cfg.labels.gront, value: '− ' + fmt(c.deduction) }); lines.push('- ' + cfg.labels.gront + ': -' + fmt(c.deduction)); }
      if (c.fee > 0) { rows.push({ label: cfg.labels.fee, value: '+ ' + fmt(c.fee) }); lines.push('+ ' + cfg.labels.fee + ': ' + fmt(c.fee)); }
      var totalStr = fmt(c.shown);
      return { rows: rows, total: totalStr, text: lines.join('\n') + '\nUPPSKATTAT PRIS: ' + totalStr };
    }

    function quoteSetHidden(form, name, val) {
      var f = form.querySelector('input[name="' + name + '"]');
      if (!f) { f = document.createElement('input'); f.type = 'hidden'; f.name = name; form.appendChild(f); }
      f.value = val;
    }

    function fillQuote() {
      if (!quoteWrap) return;
      var q = quoteData();
      var box = quoteWrap.querySelector('[data-quote-config-summary]');
      if (box) {
        /* I offertläge har produkterna 0 kr som platshållare → visa INGA belopp
           i kundens sammanfattning (raderna blev "0 kr / Totalt 0 kr"). Själva
           konfigurationen listas fortfarande, och de dolda fälten till mejlet
           är orörda så säljaren ser allt. */
        var html = '<p class="sv-offert__config-h">Din konfiguration</p><ul>';
        q.rows.forEach(function (r) {
          html += '<li><span>' + esc(r.label) + '</span>' +
                  (cfg.quoteMode ? '' : '<span>' + esc(r.value) + '</span>') + '</li>';
        });
        if (!cfg.quoteMode) {
          html += '<li class="sv-offert__config-total"><span>' + esc(cfg.labels.total) + '</span><span>' + esc(q.total) + '</span></li>';
        }
        html += '</ul>';
        box.innerHTML = html;
        box.hidden = false;
      }
      var form = quoteWrap.querySelector('form');
      if (form) {
        quoteSetHidden(form, 'contact[Konfiguration]', q.text);
        quoteSetHidden(form, 'contact[Uppskattat pris]', q.total);
      }
      /* Uppdatera befintliga produkt/pris-fält till den KONFIGURERADE titeln + totalen */
      quoteWrap.querySelectorAll('[data-quote-variant]').forEach(function (el) { el.value = baseTitle; });
      quoteWrap.querySelectorAll('[data-quote-price]').forEach(function (el) { el.value = q.total; });
      quoteWrap.querySelectorAll('[data-quote-summary-variant]').forEach(function (el) { el.textContent = baseTitle; });
      quoteWrap.querySelectorAll('[data-quote-summary-price]').forEach(function (el) { el.textContent = q.total; });
    }

    function openQuote() {
      if (!quoteWrap) return;
      /* Fyll bara innan submit – efter POST visar modalen kvitto (data-quote-status) */
      if (!quoteWrap.querySelector('[data-quote-status]')) fillQuote();
      quoteWrap.classList.add('is-open');
      quoteWrap.setAttribute('aria-hidden', 'false');
      /* overflow-hidden = samma sidlås som produktsidans offertmodal använder;
         utan den kunde sidan bakom scrollas när man scrollade i modalen. */
      document.body.classList.add('sv-offert-open', 'overflow-hidden');
      var focusEl = quoteWrap.querySelector('input[type="email"]') || quoteWrap.querySelector('.sv-offert');
      if (focusEl) { try { focusEl.focus(); } catch (e) {} }
    }

    function closeQuote() {
      if (!quoteWrap) return;
      quoteWrap.classList.remove('is-open');
      quoteWrap.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sv-offert-open', 'overflow-hidden');
    }

    if (quoteWrap) {
      quoteWrap.querySelectorAll('[data-quote-close]').forEach(function (b) { b.addEventListener('click', closeQuote); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && quoteWrap.classList.contains('is-open')) closeQuote(); });
      /* Auto-öppna efter form-POST (Shopify laddar om sidan → kvitto) */
      if (quoteWrap.querySelector('[data-quote-status]')) openQuote();
    }

    /* ===== Bottenraden får aldrig flyta ovanpå headerns menyer =====
       CSS :has-varianten förlorade mot andra regler i kaskaden → deterministisk JS i stället:
       inline-styles med priority 'important' vinner alltid. Döljer baren när en header-meny
       är öppen (details[open]) eller mega-menyn hovras. */
    var barEl = root.querySelector('.svc__bar');
    if (barEl) {
      var hoverMenus = 0;
      function updateBar() {
        var open = document.querySelector('.header-wrapper details[open], header-drawer details[open]');
        var hide = !!open || hoverMenus > 0;
        if (hide) {
          barEl.style.setProperty('opacity', '0', 'important');
          barEl.style.setProperty('visibility', 'hidden', 'important');
          barEl.style.setProperty('pointer-events', 'none', 'important');
        } else {
          barEl.style.removeProperty('opacity');
          barEl.style.removeProperty('visibility');
          barEl.style.removeProperty('pointer-events');
        }
      }
      document.addEventListener('toggle', updateBar, true);
      Array.prototype.forEach.call(document.querySelectorAll('.header-wrapper header-menu'), function (hm) {
        hm.addEventListener('mouseenter', function () { hoverMenus++; updateBar(); });
        hm.addEventListener('mouseleave', function () { hoverMenus = Math.max(0, hoverMenus - 1); setTimeout(updateBar, 150); });
      });
      updateBar();
    }

    /* Inkompatibilitets-regler (Tillval-metaobjektets `oforenlig_med`): gråar tillval som ej kan
       kombineras med basprodukten eller ett annat valt tillval. */
    if (window.SunvoltCompat) {
      window.SunvoltCompat(root, {
        rowSel: '[data-addon]',
        inputSel: '[data-addon-input]',
        noteTargetSel: '.svc__row-body',
        onChange: function () { syncRowStates(); recalc(); }
      });
    }

    /* ===== Förifylld konfiguration via URL (t.ex. från väljar-guiden) =====
       ?sv_variant=<variant-id>            – förvälj basvariant
       ?sv_install=standard|uppgraderad|ingen – förvälj installationskort
       ?sv_addons=<handle[:variantId],…>   – bocka i tillval (matchar data-sv-handle)
       ?sv_goto=summary                    – öppna direkt på summeringssteget (färdigt paket) */
    var svGotoSummary = false;
    (function () {
      var qs;
      try { qs = new URLSearchParams(window.location.search); } catch (e) { return; }
      if (!qs) return;
      if ((qs.get('sv_goto') || '') === 'summary') svGotoSummary = true;

      var wantVariant = qs.get('sv_variant');
      if (wantVariant) {
        var vc = variantCards.filter(function (c) { return c.getAttribute('data-variant-id') === wantVariant && !c.disabled; })[0];
        if (vc) selectVariant(vc);
      }

      var wantInstall = (qs.get('sv_install') || '').toLowerCase();
      if (wantInstall && installOpts.length) {
        var target = null;
        if (wantInstall === 'ingen' || wantInstall === 'none') {
          target = installOpts.filter(function (o) { return o.hasAttribute('data-install-none'); })[0];
        } else if (wantInstall.indexOf('upp') === 0 || wantInstall.indexOf('upg') === 0) {
          target = installOpts.filter(function (o) { return o.hasAttribute('data-extra-variant') && !o.disabled; })[0];
        } else if (wantInstall === 'standard' || wantInstall === 'std') {
          target = installOpts.filter(function (o) { return o.getAttribute('data-gront') && !o.hasAttribute('data-extra-variant') && !o.disabled; })[0];
        }
        if (target) selectInstall(target);
      }

      var wantAddons = (qs.get('sv_addons') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (wantAddons.length) {
        wantAddons.forEach(function (spec) {
          /* Format: handle eller handle:variantId (t.ex. laddkabel med vald längd) */
          var parts = spec.split(':');
          var h = parts[0], vid = parts[1] || '';
          var row = addonRows.filter(function (r) { return r.getAttribute('data-sv-handle') === h; })[0];
          if (!row) return;
          var input = row.querySelector('[data-addon-input]');
          if (!input || input.disabled) return;
          if (vid) {
            var sel = row.querySelector('[data-addon-variant]');
            if (sel) {
              var opt = sel.querySelector('option[value="' + vid + '"]');
              if (opt && !opt.disabled) {
                sel.value = vid;
                sel.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    })();

    /* Bottenraden hanteras helt i CSS: fast mot vyns botten, och footern målar över den
       (z-index) när man scrollar ner. Ingen JS – ett event-drivet läge kunde fastna i
       undanglidet tillstånd om scroll-/observer-callbacks uteblev.
       Body-klassen låter CSS lyfta chatt-bubblan ovanför raden (se enhancements). */
    if (root.querySelector('.svc__bar')) document.body.classList.add('sv-has-bottombar');

    syncRowStates();
    /* Från guiden (sv_goto=summary): landa direkt på summeringen med det färdiga paketet –
       flikarna/Tillbaka finns kvar för den som vill justera. */
    show(svGotoSummary ? panels.length - 1 : 0);
    recalc();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-svc]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
